/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {SupplyingPackingPlantBaseModel} from "../../api/ms-specialorders/contracts/supplying-packing-plant-base.model";

@Injectable({
    providedIn: 'root'
})
export class PartNumberChangesCreateNewService {
    readonly onCreated = new BehaviorSubject<string>(null);

    private alternativeSupplyingPackingPlants = new Subject<SupplyingPackingPlantBaseModel[]>();
    alternativeSupplyingPackingPlants$ = this.alternativeSupplyingPackingPlants.asObservable();

    sendAlternativeSppsToCreatePncDto(spp: SupplyingPackingPlantBaseModel[]) {
        this.alternativeSupplyingPackingPlants.next(spp);
    }
}
